// extracted by mini-css-extract-plugin
export default {"placeHolder":"FederationSummaryPage_placeHolder__6h0V4"};